import { Component, Input } from '@angular/core';
import { OrdersStatsSummary } from 'src/app/core/interfaces/dispatch-stats.interface';
import { STATS_LABELS } from '../../consts/stats-labels.const';

@Component({
  selector: 'app-header-stats',
  templateUrl: './header-stats.component.html'
})
export class HeaderStatsComponent {

  @Input() stats: OrdersStatsSummary;
  renderStats: Array<{
    label: string;
    value: string;
  }>;

  constructor() {
    this.renderStats = [];
  }

  ngOnChanges(): void {
    this.setRenderStats();
  }

  private setRenderStats(): void {
    this.renderStats = null;
    if (this.stats) {
      this.renderStats = Object.keys(STATS_LABELS).map((s) => {
        return {
          label: STATS_LABELS[s],
          value: this.stats[s]
        }
      });
    }
  }

}